/** Hero VRM per class id (role fallback below). Kept free of three.js so meta code can import it. */
export const HERO_VRM: Record<string, string> = {
  warden: 'tank_fumiriya',
  lightbinder: 'healer_sample_g',
  blademaster: 'melee_sample_f',
  stormcaller: 'caster_shino',
  // +classes: the five base classes reuse the four heroes; the Ranger gets the spare model.
  warrior: 'tank_fumiriya',
  acolyte: 'healer_sample_g',
  rogue: 'melee_sample_f',
  mage: 'caster_shino',
  ranger: 'spare_sample_d',
};
export const ROLE_VRM: Record<string, string> = { tank: 'tank_fumiriya', healer: 'healer_sample_g', dps: 'melee_sample_f' };
